import { z } from 'zod';
import { creerEntierOuNull, projetObligatoire } from './champs';

/**
 * Identifiant saisi à la main dans un champ texte, obligatoire. Un identifiant
 * est toujours positif.
 *
 * Ces champs partaient jusqu'ici tels que tapés : « abc » arrivait à l'API en
 * chaîne, et un champ vide en null, sans qu'aucun ne soit signalé.
 */
const identifiantObligatoire = creerEntierOuNull({
  message: 'saisir_un_identifiant',
  min: 1,
}).refine((valeur) => valeur !== null, { message: 'saisir_un_identifiant' });

/**
 * Schéma de la charge utile envoyée à la création d'une alarme XY.
 *
 * Une alarme XY applique un gabarit au couple formé par une composante de
 * capteur en X et une en Y : sans l'un de ces cinq identifiants, elle ne
 * désigne rien. Tous sont donc exigés, avec le projet.
 *
 * z.object retirant les clés qu'il ne déclare pas, les 6 clés de la charge
 * utile sont toutes déclarées.
 */
export const schemaNouvelleAlarmeXY = z.object({
  project_id: projetObligatoire,
  template_id: identifiantObligatoire,
  Xsensor_id: identifiantObligatoire,
  Xcomponent_id: identifiantObligatoire,
  Ysensor_id: identifiantObligatoire,
  Ycomponent_id: identifiantObligatoire,
});

/**
 * Schéma de la charge utile envoyée à la modification d'une alarme XY.
 * Même contrat, plus l'identifiant de l'alarme visée.
 */
export const schemaModificationAlarmeXY = schemaNouvelleAlarmeXY.extend({
  alarm_xy_id: z.coerce.number({ message: 'valeur_invalide' }).int(),
});
